var map = {
	"./CommonSlider": 356,
	"./CommonSlider.tsx": 356,
	"./ContentSections": 6621,
	"./ContentSections.tsx": 6621,
	"./ContentsWithList": 6714,
	"./ContentsWithList.tsx": 6714,
	"./Footer": 8177,
	"./Footer.tsx": 8177,
	"./FullPictureBackground": 1841,
	"./FullPictureBackground.tsx": 1841,
	"./HeaderImage": 9312,
	"./HeaderImage.tsx": 9312,
	"./HeaderSelect": 1903,
	"./HeaderSelect.tsx": 1903,
	"./Navigation": 9722,
	"./Navigation.tsx": 9722,
	"./ScreenDimensions": 5867,
	"./ScreenDimensions.tsx": 5867,
	"./TextWithImage": 8950,
	"./TextWithImage.tsx": 8950,
	"./WhiteBackground": 7977,
	"./WhiteBackground.tsx": 7977,
	"./assets/CSS/CommonSlider.css": 2543,
	"./assets/CSS/ContentSections.css": 7600,
	"./assets/CSS/ContentsWithList.css": 4725,
	"./assets/CSS/DevelopmentTimeline.css": 1621,
	"./assets/CSS/Footer.css": 9066,
	"./assets/CSS/FullPictureBackground.css": 7868,
	"./assets/CSS/HeaderSelect.css": 7472,
	"./assets/CSS/HeaderSlider.css": 7859,
	"./assets/CSS/Navigation.css": 8845,
	"./assets/CSS/Page_global.css": 8722,
	"./assets/CSS/TextWithImage.css": 7235,
	"./assets/CSS/WhiteBackground.css": 7032,
	"./assets/images/WeChat qr code.jpg": 7177,
	"./assets/images/WeChatQR.png": 5872,
	"./assets/images/Zhihui_iGuo.png": 293,
	"./assets/images/about_background.jpg": 1005,
	"./assets/images/ai_landscape.jpg": 6303,
	"./assets/images/christopher-burns-Kj2SaNHG-hg-unsplash.jpg": 3239,
	"./assets/images/christopher-burns-Kj2SaNHG-hg-unsplash_low_quanity.jpg": 9612,
	"./assets/images/code_2_landscape.jpg": 5517,
	"./assets/images/code_3_landscape.jpg": 6924,
	"./assets/images/code_vertical.jpg": 6523,
	"./assets/images/code_vertical_low_quanity.jpg": 7280,
	"./assets/images/cooperation_landscape.jpg": 6108,
	"./assets/images/cooperation_landscape_low_quanity.jpg": 847,
	"./assets/images/data_analysis_landscape.jpg": 8584,
	"./assets/images/data_analysis_landscape_low_quanity.jpg": 6203,
	"./assets/images/data_process_landscape.jpg": 7835,
	"./assets/images/data_process_landscape_low_quanity.jpg": 8272,
	"./assets/images/earth_landscape.jpg": 1373,
	"./assets/images/frequency-wave-7776034.jpg": 3326,
	"./assets/images/frequency-wave-7776034_low_quanity.jpg": 3765,
	"./assets/images/github.svg": 6828,
	"./assets/images/iguo.png": 1283,
	"./assets/images/introduce_text.png": 5960,
	"./assets/images/logo200.png": 3018,
	"./assets/images/map_landscape.jpg": 4247,
	"./assets/images/map_landscape_low_quanity.jpg": 4604,
	"./assets/images/meeting_landscape.jpg": 4286,
	"./assets/images/meeting_landscape_low_quanity.jpg": 6613,
	"./assets/images/meeting_record_landscape.jpg": 836,
	"./assets/images/meeting_record_landscape_low_quanity.jpg": 4807,
	"./assets/images/pexels-divinetechygirl-1181346.jpg": 1672,
	"./assets/images/pexels-divinetechygirl-1181346_low_quanity.jpg": 1963,
	"./assets/images/pexels-googledeepmind-17483870.jpg": 8115,
	"./assets/images/pexels-googledeepmind-17483870_low_quanity.jpg": 1912,
	"./assets/images/pexels-pixabay-267350.jpg": 9011,
	"./assets/images/pexels-pixabay-267350_low_quanity.jpg": 3822,
	"./assets/images/pexels-tara-winstead-7666429.jpg": 3658,
	"./assets/images/pexels-tara-winstead-7666429_low_quanity.jpg": 5841,
	"./assets/images/pexels-tatianasyrikova-3975586.jpg": 6255,
	"./assets/images/pexels-tatianasyrikova-3975586_low_quanity.jpg": 1348,
	"./assets/images/pexels-zch-2791918-20376383.jpg": 3569,
	"./assets/images/technology_landscape.jpg": 3635,
	"./assets/images/webpage_landscape.jpg": 3994,
	"./assets/images/webpage_landscape_low_quanity.jpg": 3377,
	"./assets/images/zhihu.svg": 9713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3763;